import React from 'react'
import { string } from 'prop-types'
import styled from '@emotion/styled'
import { Link } from '@jelly/ui'

const StyledAnchorTag = styled(Link)`
	color: ${({ theme }) => theme.colors.secondary};
	font-size: 20px;
	text-decoration: none;

	&:hover {
		color: ${({ theme }) => theme.colors.tertiary};
	}
`

const StyledButton = styled(Link)`
	${({ theme }) => theme.buttons.small};
	margin-left: 0;
	width: auto;

	${({ theme }) => theme.MQ.M} {
		margin-left: auto;
	}
`

const StyledBusinessArticle = styled.article`
	color: ${({ theme }) => theme.colors.gray[700]};
	line-height: normal;
	padding-bottom: 1rem;
	padding-top: 1rem;
	text-decoration: none;
	transition: color 0.15s ease-in;
`

const SponsoredHeadline = styled.div`
	color: ${({ theme }) => theme.colors.gray[400]};
	font-size: 16px;
	padding-bottom: 1rem;
	line-height: 1.5;
	font-weight: 400;
`

const SponsoredText = styled.div`
	color: ${({ theme }) => theme.colors.text};
	font-size: 14px;
	line-height: 1.5;
	margin-bottom: 0.5rem;
	margin-top: 0.5rem;
	word-break: break-word;
`

const ButtonWrapper = styled.div`
	text-align: right;
`

const SponsoredContentContainer = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`
const Thumbnail = styled.img`
	display: none;
	width: 100%;

	@media screen and (min-width: 321px) and (max-width: 375px) {
		display: block;
		max-width: 68px;
	}

	@media screen and (min-width: 376px) {
		display: block;
		max-width: 100px;
	}
`
const SponsoredContent = styled.div`
	padding-left: ${({ thumbnail }) => thumbnail && '10px'}; // add padding if image exists
`

CardBusinessListing.propTypes = {
	headline: string,
	thumbnail: string,
	title: string.isRequired,
	url: string.isRequired,
}

/**
 * - The CardBusinessListing is a Channels specific component with a simple UI
 * - It renders both Featured Listings (which have a picture) as well as business listings (no picture)
 */
export function CardBusinessListing({ headline, thumbnail, title, url }) {
	return (
		<StyledBusinessArticle>
			<SponsoredHeadline>Sponsored Advertisement</SponsoredHeadline>
			<SponsoredContentContainer className="inner">
				{thumbnail && <Thumbnail alt={title} src={thumbnail} />}
				<SponsoredContent thumbnail={thumbnail}>
					<StyledAnchorTag href={url}>{title}</StyledAnchorTag>
					<SponsoredText dangerouslySetInnerHTML={{ __html: headline }} />
				</SponsoredContent>
			</SponsoredContentContainer>
			<ButtonWrapper>
				<StyledButton href={url}>Learn More</StyledButton>
			</ButtonWrapper>
		</StyledBusinessArticle>
	)
}
